import React from 'react';
import { Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
export const FooterSection: React.FC = () => {
  return <footer className="bg-background border-t border-border py-6">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
            <div className="text-lg font-medium">Testera</div>
            <ul className="flex flex-wrap gap-4 md:gap-8 my-4 md:my-0">
              <li><Link to="/about-us" className="text-muted-foreground hover:text-foreground">About Us</Link></li>
              <li><Link to="/contact-us" className="text-muted-foreground hover:text-foreground">Contact Us</Link></li>
              <li><Link to="/pricing" className="text-muted-foreground hover:text-foreground">Pricing</Link></li>
              <li><Link to="/privacy-policy" className="text-muted-foreground hover:text-foreground">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" className="text-muted-foreground hover:text-foreground">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy" className="text-muted-foreground hover:text-foreground">Cancellation & Refund Policy</Link></li>
            </ul>
          </div>
          
          <div className="flex flex-col md:flex-row items-center gap-4">
            <div className="text-muted-foreground hidden md:block">Follow Us</div>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/testera-ai/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground"><Linkedin className="h-5 w-5" /></a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-border mt-4 pt-4 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Testera IT Solutions Private Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};
export default FooterSection;